// extracted by mini-css-extract-plugin
module.exports = {"Index":"completion_Index__i8s4v"};